var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSaveNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44914 1.86663V8.75921C5.44914 9.19566 4.92158 9.41414 4.61299 9.10554L3.34627 7.83874C3.15524 7.6477 2.84468 7.6477 2.65364 7.83874L1.38693 9.10554C1.07833 9.41414 0.550781 9.19566 0.550781 8.75921V1.86663C0.550781 1.32537 0.989184 0.886963 1.53045 0.886963H4.46946C5.01073 0.886963 5.44914 1.32537 5.44914 1.86663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSaveNew);
export default __webpack_public_path__ + "static/media/icon-save-new.ccc8fc663eadbf27a91da4a44c2a2816.svg";
export { ForwardRef as ReactComponent };